import React from "react";
import { I18n } from "@aws-amplify/core";
import { withStyles } from "@material-ui/styles";
import PropTypes from "prop-types";
import { isEmpty, map, get, toLower, trim } from "lodash";

import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";

import TagColor from "./TagColor";
import ZoneColor from "./ZoneColor";

import { getAttributeName } from "../../utils/attributes";

import colors from "../../assets/style/colors";

const styles = {
  link: {
    color: colors.primary,
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
};

const InfoSection = (props) => {
  const { classes, attribute, title, title2, values, link } = props;

  return (
    <Grid item style={{ padding: "8px", maxWidth: "100%", ...props.style }}>
      <Box className={"text-87 bold-500"}>
        {get(attribute, ["id"])
          ? getAttributeName(get(attribute, ["id"]))
          : title2
          ? title2
          : I18n.get("profiles_" + title)}
      </Box>
      {link && !isEmpty(link) ? (
        link.value ? (
          <span className={classes.link} onClick={link.onClick}>
            {link.value}
          </span>
        ) : (
          "-"
        )
      ) : title === "color" ? (
        <ZoneColor color={props.color} />
      ) : !values || values.length === 0 ? (
        <span className="text-54">-</span>
      ) : (
        map(values, (item, index) => (
          <Grid
            container
            key={item + index}
            wrap="nowrap"
            style={{
              marginBottom: values.length > 0 ? "8px" : "0px",
              overflowWrap: "break-word",
            }}
          >
            {title === "tag" && <TagColor color={"#" + props.color} />}
            <Grid
              item
              style={{ overflow: "auto" }}
              data-automation={
                get(attribute, ["id"])
                  ? `data_field_attribute_${get(attribute, ["id"])}`
                  : title2
                  ? `data_field_attribute_${toLower(trim(title2))}`
                  : `data_field_attribute_${toLower(title)}`
              }
            >
              {typeof item === "boolean" && item ? (
                <span className="text-54">{I18n.get("profiles_yes")}</span>
              ) : typeof item === "boolean" && !item ? (
                <span className="text-54">{I18n.get("profiles_no")}</span>
              ) : (
                <span className="text-54">{item || "-"}</span>
              )}
            </Grid>
          </Grid>
        ))
      )}
    </Grid>
  );
};

InfoSection.propTypes = {
  title: PropTypes.string,
  values: PropTypes.array.isRequired,
};

export default withStyles(styles)(InfoSection);
